"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _DateiBase = _interopRequireDefault(require("./DateiBase"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * KFV LDS API
 * Die KFV LDS API bietet eine Schnittstelle zum Backend der PWA.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The BeitragCreate model module.
 * @module model/BeitragCreate
 * @version 0.0.1
 */
class BeitragCreate {
  /**
   * Constructs a new <code>BeitragCreate</code>.
   * @alias module:model/BeitragCreate
   * @param titel {String} 
   * @param body {String} 
   * @param feuerwehrId {Number} 
   */
  constructor(titel, body, feuerwehrId) {
    BeitragCreate.initialize(this, titel, body, feuerwehrId);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, titel, body, feuerwehrId) {
    obj['titel'] = titel;
    obj['body'] = body;
    obj['feuerwehr_id'] = feuerwehrId;
  }

  /**
   * Constructs a <code>BeitragCreate</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/BeitragCreate} obj Optional instance to populate.
   * @return {module:model/BeitragCreate} The populated <code>BeitragCreate</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new BeitragCreate();
      if (data.hasOwnProperty('titel')) {
        obj['titel'] = _ApiClient.default.convertToType(data['titel'], 'String');
      }
      if (data.hasOwnProperty('body')) {
        obj['body'] = _ApiClient.default.convertToType(data['body'], 'String');
      }
      if (data.hasOwnProperty('bild')) {
        obj['bild'] = _DateiBase.default.constructFromObject(data['bild']);
      }
      if (data.hasOwnProperty('feuerwehr_id')) {
        obj['feuerwehr_id'] = _ApiClient.default.convertToType(data['feuerwehr_id'], 'Number');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>BeitragCreate</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>BeitragCreate</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of BeitragCreate.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['titel'] && !(typeof data['titel'] === 'string' || data['titel'] instanceof String)) {
      throw new Error("Expected the field `titel` to be a primitive type in the JSON string but got " + data['titel']);
    }
    // ensure the json data is a string
    if (data['body'] && !(typeof data['body'] === 'string' || data['body'] instanceof String)) {
      throw new Error("Expected the field `body` to be a primitive type in the JSON string but got " + data['body']);
    }
    // validate the optional field `bild`
    if (data['bild']) {
      // data not null
      _DateiBase.default.validateJSON(data['bild']);
    }
    return true;
  }
}
BeitragCreate.RequiredProperties = ["titel", "body", "feuerwehr_id"];

/**
 * @member {String} titel
 */
BeitragCreate.prototype['titel'] = undefined;

/**
 * @member {String} body
 */
BeitragCreate.prototype['body'] = undefined;

/**
 * @member {module:model/DateiBase} bild
 */
BeitragCreate.prototype['bild'] = undefined;

/**
 * @member {Number} feuerwehr_id
 */
BeitragCreate.prototype['feuerwehr_id'] = undefined;
var _default = exports.default = BeitragCreate;